export default __webpack_public_path__ + "images/examples-s4jMq.png";